var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssuranceMaintenanceFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.697,
    height: 22.337,
    viewBox: "0 0 17.697 22.337",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1053",
    "data-name": "Group 1053",
    transform: "translate(-161.479 -1142.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_542",
    "data-name": "Group 542",
    transform: "translate(161.479 1142.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M1128.058,3344.319l-4.82-4.906a.354.354,0,0,0-.251-.107H1114.1a2.551,2.551,0,0,0-2.433,2.655v9.793h-1.184v6.639h1.184v.6a2.556,2.556,0,0,0,2.433,2.653h11.645a2.55,2.55,0,0,0,2.434-2.653v-14.381A.408.408,0,0,0,1128.058,3344.319Zm-5.191-4.191,4.192,4.271h-2.283a1.927,1.927,0,0,1-1.91-1.94Zm4.573,18.862a1.782,1.782,0,0,1-1.7,1.854H1114.1a1.782,1.782,0,0,1-1.7-1.854v-.6h8.083a3.357,3.357,0,0,0,0-6.639H1112.4v-9.793a1.782,1.782,0,0,1,1.7-1.854h8.036v2.353a2.7,2.7,0,0,0,2.645,2.74h2.663v13.791Zm-14.687-2.243V3353.4h1.24a1.159,1.159,0,0,1,.839.286,1.007,1.007,0,0,1,.3.755.981.981,0,0,1-.3.754,1.193,1.193,0,0,1-.839.287h-.7v1.268Zm3.038,0V3353.4h1.073a1.348,1.348,0,0,1,1,.4,1.4,1.4,0,0,1,.384,1.023v.509a1.412,1.412,0,0,1-.384,1.024,1.347,1.347,0,0,1-1,.4Zm5.041-1.877v.447h-1.306v1.429h-.544V3353.4h2.075v.447h-1.534v1.023h1.309Z",
    transform: "translate(-1110.478 -3339.306)",
    fill: "#f8c95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M1114.177,3353.469a.607.607,0,0,0,.151-.419.62.62,0,0,0-.151-.425.58.58,0,0,0-.454-.17h-.7v1.184h.7A.6.6,0,0,0,1114.177,3353.469Z",
    transform: "translate(-1110.209 -3337.913)",
    fill: "#f8c95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M1116.3,3352.455h-.532v2.457h.532a.762.762,0,0,0,.618-.272,1.069,1.069,0,0,0,.229-.7v-.514a1.062,1.062,0,0,0-.229-.7A.76.76,0,0,0,1116.3,3352.455Z",
    transform: "translate(-1109.917 -3337.913)",
    fill: "#f8c95a"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3766",
    "data-name": "Rectangle 3766",
    width: 9,
    height: 4,
    transform: "translate(162.988 1156)",
    fill: "#f8c95a"
  }), /*#__PURE__*/React.createElement("text", {
    id: "AM",
    transform: "translate(163.488 1160)",
    fill: "#0b2241",
    fontSize: 5,
    fontFamily: "Helvetica",
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "AM")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssuranceMaintenanceFileIcon);
export default __webpack_public_path__ + "static/media/assurance-maintenance-file-icon.7b3182974be888ac736eaf85114516ca.svg";
export { ForwardRef as ReactComponent };